import type {
  GenericKeyboardEvent,
  VirtualScrollContextState as Props
} from '../../types';

const useEventsHandler = ({
  currentIndex,
  dataRef,
  setCurrentIndex,
  virtuosoRef
}: Props) => {
  const scrollIntoView = (e: GenericKeyboardEvent, index: number) => {
    virtuosoRef.current?.scrollIntoView({
      index,
      behavior: 'auto',
      done: () => {
        setCurrentIndex(index);
      }
    });

    e.preventDefault();
  };

  const handleKeyEvent = (e: GenericKeyboardEvent) => {
    let nextIndex: number | undefined;

    const data = dataRef.current;
    if (!data) return;

    if (e.code === 'ArrowUp') {
      if (currentIndex <= -1) {
        return;
      }

      nextIndex = currentIndex - 1;
    }

    if (e.code === 'ArrowDown') {
      if (currentIndex >= data.length) {
        return;
      }

      nextIndex = currentIndex + 1;
    }

    if (nextIndex !== undefined) {
      scrollIntoView(e, nextIndex);
    }
  };

  return { handleKeyEvent };
};

export default useEventsHandler;
